import { MinzeElement, Reactive, EventListeners } from "minze";
import { MODALS } from "../../constants";
import { ModalStatusEvent } from "../modal";

export interface TjSearchWrapper {
}

export class TjSearchWrapper extends MinzeElement {
  attrs = ["data-group-id"];
 
  reactive: Reactive = [
    ["modalStatus", "show"],
    ["isDesktop", true],
  ];

  toggleContainer = (event: Event) => {
    const detail = (event as CustomEvent<ModalStatusEvent>).detail;
    if (detail.modalId === MODALS.SEARCH_CONTAINER) {
      if (detail.status === "show") {
        this.modalStatus = "show";
      } else {
        this.modalStatus = "hide";
      }
    }
  };

  html = () => /* html */ `
    <tj-search-desktop-wrapper data-group-id="${this.dataGroupId}"></tj-search-desktop-wrapper>
  `;

  css = () => `
    :host {
    }

    .tj-search-container.show {
      display: block
    }

    .tj-search-container.hide {
      display: none
    }
  `;

  eventListeners: EventListeners = [
    [window, "tj:toggle-modal", this.toggleContainer]
  ];
}
